import { render, staticRenderFns } from "./monthwork.vue?vue&type=template&id=279b221e&scoped=true"
import script from "./monthwork.vue?vue&type=script&lang=js"
export * from "./monthwork.vue?vue&type=script&lang=js"
import style0 from "./monthwork.vue?vue&type=style&index=0&id=279b221e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b221e",
  null
  
)

export default component.exports